<template>
    <span>
        {{ title }}
    </span>
</template>

<script>
    export default {
        props: [
            'text'
        ],
        data() {
            return {
            }
        },
        computed: {
            title() {
                return _.split(this.text, '\n')[0];
            }
        }
    }
</script>
